var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-avatar',{attrs:{"color":_vm.borderColor,"size":_vm.avatarSize}},[_c('v-img',{attrs:{"src":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }